import { render, staticRenderFns } from "./ProjectShowDiariesTab.vue?vue&type=template&id=5f3a1048"
import script from "./ProjectShowDiariesTab.vue?vue&type=script&lang=ts"
export * from "./ProjectShowDiariesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports